import React from 'react';
import HeaderCell from './HeaderCell';
import PuzzleCheckbox from '../../UI/checkbox/PuzzleCheckbox';
import * as _ from 'lodash';
import { HEADER_CELL_CHECKBOX_PROPS } from './Types';

class HeaderCellCheckbox extends HeaderCell<HEADER_CELL_CHECKBOX_PROPS, {}> {
  renderInnerCell = () => {
    const {
      headerCellConfig = {},
      onHeaderChange,
      checked,
      disabled
    } = this.props;
    const { ariaLabel, label = '', labelPlacement = 'after', tooltipPosition = 'bottom', withTooltip = true } = headerCellConfig;
    return (
      <PuzzleCheckbox
        aria-label={ariaLabel}
        data-cy="key-header-checkbox"
        onChange={(e) => {
          onHeaderChange({
            field: this.props.field,
            syntheticEvent: e
          });
        }}
        label={label}
        labelPlacement={labelPlacement}
        checked={checked}
        disabled={disabled}
        titleText={label}
        tooltipPosition={tooltipPosition}
        withTooltip={withTooltip}
      />
    );
  };
}

export default HeaderCellCheckbox;
